import loader from "./loader"
export default loader;
